import Vue from 'vue'

// 共享数据源：各页面进入时由 loadPageData 从接口刷新
export const resource = Vue.observable({
  projects: [],
  beacons: [],
  stations: [],
  accounts: [],
  zones: [],
  apiProjects: [],
  apiBuildings: [],
  apiFloors: [],
  homeStats: {
    project_total: 0,
    device_total: 0,
    device_online_count: 0,
    base_station_total: 0,
    base_station_online_count: 0
  }
})

export default resource
